(function () {
  /* 2026-08-28: pill now serves orbit (114891065) AND the compression short
     sleeve (209873286). Bind the instance whose design id is in the hash. */
  var __xpHash = window.location.hash || '';
  if (window.location.pathname.indexOf('/pages/3d-customizer') === -1 || (__xpHash.indexOf('114891065') === -1 && __xpHash.indexOf('209873286') === -1)) return;

  var __xpRoots = document.querySelectorAll('[data-xeist-backpack-price-pill]');
  var root = null;
  for (var __xpI = 0; __xpI < __xpRoots.length; __xpI++) {
    var __xpDid = __xpRoots[__xpI].getAttribute('data-design-id') || '';
    if (__xpDid && __xpHash.indexOf(__xpDid) !== -1) { root = __xpRoots[__xpI]; break; }
  }
  if (!root) root = __xpRoots[0];
  if (!root) return;

  var POLL_INTERVAL = 700;
  var FALLBACK_TICKS = 8;
  var CART_REDIRECT_DELAY = 1400;
  var lastHash = '';
  var fallbackCounter = 0;
  var pulseTimer = null;
  var boundQuantityInput = null;
  var manualQuantity = null;
  var isSubmitting = false;

  function toNumber(value, fallback) {
    var parsed = parseFloat(value);
    return isFinite(parsed) ? parsed : fallback;
  }

  function toInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }

  function toList(value, fallback) {
    return String(value || fallback || '')
      .split(',')
      .map(function (item) { return item.trim().toLowerCase(); })
      .filter(Boolean);
  }

  function pluralize(word, count) {
    return count === 1 ? word : word + 's';
  }

  function sanitizeQuantity(value) {
    return Math.max(1, toInt(value, 1));
  }

  var config = {
    productSlug: String(root.getAttribute('data-product-slug') || 'orbit-backpack').toLowerCase(),
    designId: String(root.getAttribute('data-design-id') || '').toLowerCase(),
    basePrice: toNumber(root.getAttribute('data-base-price'), 54.99),
    logoPrice: toNumber(root.getAttribute('data-logo-price'), 5),
    numberPrice: toNumber(root.getAttribute('data-number-price'), 6),
    defaultQty: sanitizeQuantity(root.getAttribute('data-default-qty') || 1),
    logoKeys: toList(root.getAttribute('data-logo-placement-keys'), 'logo,crest,badge'),
    noun: String(root.getAttribute('data-noun') || 'bag')
  };

  var elements = {
    status: root.querySelector('[data-pill-status]'),
    base: root.querySelector('[data-pill-base]'),
    logo: root.querySelector('[data-pill-logo]'),
    number: root.querySelector('[data-pill-number]'),
    meta: root.querySelector('[data-pill-meta]'),
    total: root.querySelector('[data-pill-total]'),
    unit: root.querySelector('[data-pill-unit]'),
    qtyInput: root.querySelector('[data-pill-qty-input]'),
    decrease: root.querySelector('[data-pill-decrease]'),
    increase: root.querySelector('[data-pill-increase]'),
    add: root.querySelector('[data-pill-add]')
  };

  function formatMoney(value) {
    try {
      return new Intl.NumberFormat('en-CA', {
        style: 'currency',
        currency: 'CAD'
      }).format(value);
    } catch (error) {
      return '$' + value.toFixed(2);
    }
  }

  function removeLegacyWidget(id) {
    var node = document.getElementById(id);
    if (node) node.remove();
  }

  function cleanupLegacyOrbitUi() {
    removeLegacyWidget('xeist-orbit-quantity-pricing');
    removeLegacyWidget('xeist-orbit-quantity-pricing-style');
    removeLegacyWidget('xeist-orbit-volume-pricing');
    removeLegacyWidget('xeist-orbit-volume-pricing-style');
  }

  function setStatus(text, tone) {
    if (!elements.status) return;
    elements.status.textContent = text;
    elements.status.setAttribute('data-tone', tone || 'ready');
  }

  function findScopeWith(scope, key) {
    var current = scope;
    while (current && !current[key]) current = current.$parent;
    return current || null;
  }

  function getAngularScope(node) {
    if (!window.angular || !node) return null;

    try {
      return window.angular.element(node).scope() || null;
    } catch (error) {
      return null;
    }
  }

  function getItemDescriptor(item) {
    return [
      item && item.placementKey,
      item && item.name,
      item && item.label,
      item && item.orderChargeDescription,
      item && item.type,
      item && item.id
    ].filter(Boolean).join(' ').toLowerCase();
  }

  function matchesHints(text, hints) {
    if (!text) return false;

    for (var i = 0; i < hints.length; i++) {
      if (text.indexOf(hints[i]) !== -1) return true;
    }

    return false;
  }

  function placementHasSelection(placement) {
    if (!placement) return false;
    if (placement.selected || placement.isSelected || placement.active) return true;
    if (placement.image || placement.value || placement.text) return true;
    if (placement.images && placement.images.length) return true;
    if (placement.editorItems && placement.editorItems.length) return true;
    return false;
  }

  function collectRosterEntries(teamDetails) {
    if (!teamDetails) return [];

    var source = teamDetails.players || teamDetails.namesnumbers || teamDetails.roster;
    if (!source) return [];
    if (Array.isArray(source)) return source;

    var entries = [];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key) && source[key]) {
        entries.push(source[key]);
      }
    }

    return entries;
  }

  function getKitBuilderContext() {
    var orderGroup = document.querySelector('.kb-group-order');
    var editPanel = document.querySelector('.kb-customise-edit-panel');
    var previewPanel = document.querySelector('.kb-preview-panel');
    var quantityInput = editPanel && editPanel.querySelector('.kb-aggregate-size-quantity-input');
    var scopeSource = quantityInput || orderGroup || editPanel || document.getElementById('kitBuilder');
    var scope = getAngularScope(scopeSource);
    var fallbackContext = {
      hasAngular: false,
      orderGroup: orderGroup,
      editPanel: editPanel,
      previewPanel: previewPanel,
      quantityInput: quantityInput,
      productSlug: '',
      isOrderStep: !!orderGroup,
      customizeService: null,
      kit: null
    };

    if (!scope) return fallbackContext;

    var customizeScope = findScopeWith(scope, 'CustomizeService');
    var kitScope = findScopeWith(scope, 'KitService');
    var stepScope = findScopeWith(scope, 'StepService');
    if (!customizeScope || !customizeScope.CustomizeService) return fallbackContext;

    var customizeService = customizeScope.CustomizeService;
    var stepData = stepScope && stepScope.StepService ? stepScope.StepService.data : null;

    return {
      hasAngular: true,
      orderGroup: orderGroup,
      editPanel: editPanel,
      previewPanel: previewPanel,
      quantityInput: quantityInput,
      productSlug: customizeService.design && customizeService.design.productUrlSlug
        ? String(customizeService.design.productUrlSlug).toLowerCase()
        : '',
      isOrderStep: stepData && stepData.steps
        ? stepData.stepIndex === (stepData.steps.length - 1)
        : !!orderGroup,
      customizeService: customizeService,
      kit: kitScope && kitScope.KitService ? kitScope.KitService.kit : null
    };
  }

  function getContextQuantity(context) {
    var quantity = 0;
    var sizes = context && context.kit &&
      context.kit.teamdetails &&
      context.kit.teamdetails.sizes;

    if (sizes) {
      for (var sizeId in sizes) {
        if (Object.prototype.hasOwnProperty.call(sizes, sizeId)) {
          quantity += toInt(sizes[sizeId], 0);
        }
      }
    }

    if (!quantity && context.quantityInput) {
      quantity = sanitizeQuantity(context.quantityInput.value || config.defaultQty);
    }

    return quantity || config.defaultQty;
  }

  function getActiveQuantity(context) {
    if (manualQuantity !== null) return sanitizeQuantity(manualQuantity);
    return getContextQuantity(context);
  }

  function hasLogoSelection(context) {
    var editorItems = context.kit && Array.isArray(context.kit.editor) ? context.kit.editor : [];
    var placements = context.customizeService && context.customizeService.editorPlacements
      ? context.customizeService.editorPlacements
      : [];

    for (var i = 0; i < editorItems.length; i++) {
      var item = editorItems[i];
      if (item.type === 'image') return true;
      if (matchesHints(getItemDescriptor(item), config.logoKeys) && (item.image || item.src || item.value)) return true;
    }

    for (var j = 0; j < placements.length; j++) {
      if (matchesHints(getItemDescriptor(placements[j]), config.logoKeys) && placementHasSelection(placements[j])) {
        return true;
      }
    }

    return false;
  }

  function hasNumberSelection(context) {
    /* Prefer bridge if available */
    var bridge = window.XeistKBBridge;
    if (bridge && typeof bridge.hasNumber === 'function') {
      var state = bridge.hasNumber();
      return state && state.hasNumber;
    }

    /* Fallback: check editor items for text items on the number placement */
    var coachConfig = window.XeistOrbitCoachConfig || {};
    var numberKeys = Array.isArray(coachConfig.numberPlacementKeys)
      ? coachConfig.numberPlacementKeys
      : ['add-number', 'number'];
    var editorItems = context.kit && Array.isArray(context.kit.editor) ? context.kit.editor : [];

    for (var i = 0; i < editorItems.length; i++) {
      var item = editorItems[i];
      if (item.type !== 'text') continue;
      var pk = String(item.placementKey || '').toLowerCase();
      for (var j = 0; j < numberKeys.length; j++) {
        if (pk === numberKeys[j].toLowerCase()) return true;
      }
    }

    return false;
  }

  function getConfiguredPriceTiers() {
    /* data-tiers on the root (KB Simple Price Tiers, per design) wins;
       XeistOrbitCoachConfig stays the orbit fallback. */
    var dataTiers = root.getAttribute('data-tiers');
    if (dataTiers) {
      try {
        var parsed = JSON.parse(dataTiers);
        var fromAttr = [];
        for (var ti = 0; ti < parsed.length; ti++) {
          var tMin = toInt(parsed[ti] && parsed[ti].min, null);
          if (tMin === null) continue;
          fromAttr.push({ min: tMin, price: toNumber(parsed[ti].unitPrice, config.basePrice) });
        }
        if (fromAttr.length) {
          fromAttr.sort(function (left, right) { return right.min - left.min; });
          return fromAttr;
        }
      } catch (e) {}
    }
    var coachConfig = window.XeistOrbitCoachConfig || {};
    var pricing = coachConfig.pricing || {};
    var tiers = Array.isArray(pricing.baseTiers) ? pricing.baseTiers : [];
    var normalized = [];

    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i] || {};
      var min = toInt(tier.min, null);
      if (min === null) continue;

      normalized.push({
        min: min,
        price: toNumber(tier.unitPrice, config.basePrice)
      });
    }

    if (!normalized.length) {
      normalized = [
        { min: 100, price: 49.99 },
        { min: 50,  price: 51.50 },
        { min: 25,  price: 52.99 },
        { min: 1,   price: 54.99 }
      ];
    }

    normalized.sort(function (left, right) {
      return right.min - left.min;
    });

    return normalized;
  }

  /* Volume price tiers (CAD) — base price per bag by quantity */
  var PRICE_TIERS = getConfiguredPriceTiers();

  function getTierPrice(quantity) {
    for (var i = 0; i < PRICE_TIERS.length; i++) {
      if (quantity >= PRICE_TIERS[i].min) return PRICE_TIERS[i].price;
    }
    return config.basePrice;
  }

  function computePrice(context) {
    var quantity = getActiveQuantity(context);
    var logoSelected = context.hasAngular ? hasLogoSelection(context) : false;
    var numberSelected = hasNumberSelection(context);
    var logoCharge = logoSelected ? config.logoPrice : 0;
    var numberCharge = numberSelected ? config.numberPrice : 0;
    var tierBase = getTierPrice(quantity);
    var unitPrice = tierBase + logoCharge + numberCharge;

    return {
      quantity: quantity,
      tierBase: tierBase,
      logoCharge: logoCharge,
      numberCharge: numberCharge,
      unitPrice: unitPrice,
      totalPrice: unitPrice * quantity
    };
  }

  function updateSignal(element, text, active, accent) {
    if (!element) return;
    element.textContent = text;
    element.setAttribute('data-active', active ? 'true' : 'false');
    if (accent) element.setAttribute('data-accent', accent);
  }

  function syncPillQuantityInput(quantity) {
    if (!elements.qtyInput) return;
    var normalized = String(sanitizeQuantity(quantity));
    if (elements.qtyInput.value !== normalized) {
      elements.qtyInput.value = normalized;
    }
  }

  function bindQuantityInput(input) {
    if (!input || input === boundQuantityInput) return;

    boundQuantityInput = input;
    ['input', 'change', 'blur'].forEach(function (eventName) {
      input.addEventListener(eventName, function () {
        manualQuantity = sanitizeQuantity(input.value || config.defaultQty);
        syncPillQuantityInput(manualQuantity);
        update();
      });
    });
  }

  function syncNativeQuantity(context, quantity) {
    if (!context || !context.quantityInput) return false;

    var normalized = sanitizeQuantity(quantity);
    var input = context.quantityInput;
    if (sanitizeQuantity(input.value || config.defaultQty) === normalized) return true;

    input.focus();
    input.value = normalized;
    ['input', 'change', 'keyup', 'blur'].forEach(function (eventName) {
      input.dispatchEvent(new Event(eventName, { bubbles: true }));
    });

    try {
      var scope = getAngularScope(input);
      if (scope && scope.$applyAsync) scope.$applyAsync();
    } catch (error) {
      /* noop */
    }

    return true;
  }

  function getMountNode(orderGroup, quantityInput) {
    var node = quantityInput;
    while (node && node.parentNode && node.parentNode !== orderGroup) {
      node = node.parentNode;
    }

    return node && node.parentNode === orderGroup ? node : null;
  }

  function mountIntoCustomizer(context) {
    if (context.previewPanel && window.innerWidth >= 990) {
      if (window.getComputedStyle(context.previewPanel).position === 'static') {
        context.previewPanel.style.position = 'relative';
      }
      if (root.parentNode !== context.previewPanel) {
        context.previewPanel.appendChild(root);
      }
      root.classList.add('xeist-backpack-price-pill--overlay');
      return;
    }

    root.classList.remove('xeist-backpack-price-pill--overlay');

    if (context.orderGroup) {
      var mountNode = getMountNode(context.orderGroup, context.quantityInput);
      if (mountNode && mountNode.insertAdjacentElement) {
        if (root.parentNode !== context.orderGroup) {
          mountNode.insertAdjacentElement('afterend', root);
        }
        return;
      }

      var checkout = context.orderGroup.querySelector('.kb-single-item-checkout');
      if (checkout) {
        if (root.parentNode !== context.orderGroup) {
          context.orderGroup.insertBefore(root, checkout);
        }
      } else {
        if (root.parentNode !== context.orderGroup) {
          context.orderGroup.appendChild(root);
        }
      }
      return;
    }

    if (!context.editPanel) return;

    var firstHeader = context.editPanel.querySelector('.kb-editor-heading.kb-wizard-group-header, .kb-wizard-group-header, .kb-editor-heading');
    if (firstHeader && firstHeader.parentNode) {
      if (root.parentNode !== firstHeader.parentNode) {
        firstHeader.parentNode.insertBefore(root, firstHeader);
      }
      return;
    }

    if (root.parentNode !== context.editPanel) {
      context.editPanel.insertBefore(root, context.editPanel.firstChild);
    }
  }

  function getClickableTarget(node) {
    var current = node;
    while (current && current !== document.body) {
      if (current.matches && current.matches('button, a, [ng-click], li, [role="button"]')) {
        return current;
      }
      current = current.parentNode;
    }
    return null;
  }

  function findClickableByText(container, text) {
    if (!container) return null;

    var candidates = container.querySelectorAll('button, a, [ng-click], li, span, div');
    var targetText = text.toLowerCase();

    for (var i = 0; i < candidates.length; i++) {
      var candidate = candidates[i];
      if (root.contains(candidate) || !candidate.offsetParent) continue;

      var candidateText = String(candidate.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (candidateText !== targetText) continue;

      var clickable = getClickableTarget(candidate);
      if (clickable && clickable !== root) return clickable;
    }

    return null;
  }

  function waitFor(condition, timeoutMs, intervalMs) {
    return new Promise(function (resolve, reject) {
      var started = Date.now();
      var timer = window.setInterval(function () {
        var result = condition();
        if (result) {
          window.clearInterval(timer);
          resolve(result);
          return;
        }

        if (Date.now() - started >= timeoutMs) {
          window.clearInterval(timer);
          reject(new Error('Timed out'));
        }
      }, intervalMs || 150);
    });
  }

  function goToOrderStep(context) {
    if (context.isOrderStep) return Promise.resolve(context);

    var trigger = findClickableByText(context.editPanel || document, 'order') ||
      findClickableByText(context.editPanel || document, 'next');

    if (!trigger) {
      return Promise.reject(new Error('Order step trigger not found'));
    }

    trigger.click();

    return waitFor(function () {
      var refreshed = getKitBuilderContext();
      if (refreshed && refreshed.isOrderStep && refreshed.quantityInput) {
        return refreshed;
      }
      return null;
    }, 10000, 180);
  }

  function findNativeAddToCartButton() {
    return document.querySelector('.kb-button-single-item-checkout-add-to-cart');
  }

  function triggerNativeAddToCart(context) {
    try {
      var scopeSource = context.quantityInput || context.orderGroup || context.editPanel;
      var scope = getAngularScope(scopeSource);
      var addScope = findScopeWith(scope, 'addToCart');
      if (addScope && addScope.addToCart) {
        if (addScope.$applyAsync) {
          addScope.$applyAsync(function () { addScope.addToCart(); });
        } else {
          addScope.$apply(function () { addScope.addToCart(); });
        }
        return true;
      }
    } catch (error) {
      /* fall through */
    }

    var nativeBtn = findNativeAddToCartButton();
    if (nativeBtn) {
      nativeBtn.click();
      return true;
    }

    return false;
  }

  function queueQuantity(quantity) {
    manualQuantity = sanitizeQuantity(quantity);
    syncPillQuantityInput(manualQuantity);

    var context = getKitBuilderContext();
    if (context.isOrderStep && context.quantityInput) {
      syncNativeQuantity(context, manualQuantity);
    }

    update();
  }

  function handleQuantityInput() {
    queueQuantity(elements.qtyInput ? elements.qtyInput.value : config.defaultQty);
  }

  function handleAddToCart() {
    if (isSubmitting) return;

    var requestedQty = sanitizeQuantity(elements.qtyInput ? elements.qtyInput.value : manualQuantity || config.defaultQty);
    queueQuantity(requestedQty);
    isSubmitting = true;
    root.classList.add('is-submitting');
    setStatus('Routing', 'busy');

    goToOrderStep(getKitBuilderContext())
      .then(function (orderContext) {
        setStatus('Syncing', 'busy');
        syncNativeQuantity(orderContext, requestedQty);

        return waitFor(function () {
          var refreshed = getKitBuilderContext();
          if (refreshed && refreshed.isOrderStep) {
            syncNativeQuantity(refreshed, requestedQty);
            return refreshed;
          }
          return null;
        }, 3000, 120);
      })
      .then(function (readyContext) {
        setStatus('Adding', 'busy');
        if (!triggerNativeAddToCart(readyContext)) {
          throw new Error('Add to cart unavailable');
        }

        setStatus('Cart', 'success');
        window.setTimeout(function () {
          window.location.href = window.location.origin + '/cart';
        }, CART_REDIRECT_DELAY);
      })
      .catch(function () {
        setStatus('Go to Order', 'error');
        isSubmitting = false;
        root.classList.remove('is-submitting');
        window.setTimeout(update, 1400);
      });
  }

  function pulseTotal() {
    root.classList.add('is-updating');
    window.clearTimeout(pulseTimer);
    pulseTimer = window.setTimeout(function () {
      root.classList.remove('is-updating');
    }, 220);
  }

  function render(price, context) {
    mountIntoCustomizer(context);
    root.hidden = false;
    bindQuantityInput(context.quantityInput);

    if (context.isOrderStep && manualQuantity !== null) {
      syncNativeQuantity(context, manualQuantity);
    }

    syncPillQuantityInput(price.quantity);

    if (elements.total) elements.total.textContent = formatMoney(price.totalPrice);
    if (elements.unit) elements.unit.textContent = formatMoney(price.unitPrice);
    if (elements.meta) {
      elements.meta.textContent = [
        price.quantity + ' ' + pluralize(config.noun, price.quantity),
        formatMoney(price.unitPrice) + ' each'
      ].join(' · ');
    }
    if (elements.base) elements.base.textContent = 'Base ' + formatMoney(price.tierBase);
    updateSignal(elements.logo, price.logoCharge > 0 ? 'Logo +' + formatMoney(price.logoCharge) : 'Logo off', price.logoCharge > 0, 'logo');
    updateSignal(elements.number, price.numberCharge > 0 ? 'Number +' + formatMoney(price.numberCharge) : 'Number off', price.numberCharge > 0, 'number');

    if (elements.add) {
      elements.add.textContent = isSubmitting
        ? 'Opening Cart...'
        : 'Add to Cart';
      elements.add.disabled = !!isSubmitting;
    }

    if (!isSubmitting) {
      setStatus(context.isOrderStep ? 'Order ready' : 'Design step', 'ready');
    }
  }

  function update() {
    var context = getKitBuilderContext();
    var hashTarget = config.designId && window.location.hash.toLowerCase().indexOf('/customise/' + config.designId) !== -1;
    var isTargetProduct = context.productSlug
      ? context.productSlug === config.productSlug
      : hashTarget;

    cleanupLegacyOrbitUi();

    if (!isTargetProduct || !context.previewPanel) {
      root.hidden = true;
      root.classList.remove('xeist-backpack-price-pill--overlay');
      lastHash = '';
      return;
    }

    if (!context.hasAngular) {
      fallbackCounter += 1;
      if (fallbackCounter < FALLBACK_TICKS) return;
    } else {
      fallbackCounter = 0;
    }

    var price = computePrice(context);
    var currentHash = [
      context.productSlug || config.productSlug,
      context.isOrderStep ? 'order' : 'customise',
      price.quantity,
      price.logoCharge,
      price.numberCharge,
      price.totalPrice,
      isSubmitting ? 'busy' : 'idle'
    ].join('|');

    if (currentHash === lastHash && !root.hidden) {
      return;
    }

    if (lastHash && currentHash !== lastHash) {
      pulseTotal();
    }

    lastHash = currentHash;
    render(price, context);
  }

  function init() {
    if (elements.decrease) {
      elements.decrease.addEventListener('click', function () {
        queueQuantity(getActiveQuantity(getKitBuilderContext()) - 1);
      });
    }

    if (elements.increase) {
      elements.increase.addEventListener('click', function () {
        queueQuantity(getActiveQuantity(getKitBuilderContext()) + 1);
      });
    }

    if (elements.qtyInput) {
      ['input', 'change', 'blur'].forEach(function (eventName) {
        elements.qtyInput.addEventListener(eventName, handleQuantityInput);
      });
    }

    if (elements.add) {
      elements.add.addEventListener('click', handleAddToCart);
    }

    update();

    var target = document.getElementById('kitBuilder') || document.body;
    var observer = new MutationObserver(function () {
      window.requestAnimationFrame(update);
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      attributes: true
    });

    window.setInterval(update, POLL_INTERVAL);
    window.addEventListener('hashchange', function () {
      window.setTimeout(function () {
        isSubmitting = false;
        root.classList.remove('is-submitting');
        update();
      }, 120);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
